import type { BigIntish } from '@morpho-org/blue-sdk'

import { toBigInt } from '@morpho-org/dapp-core'

import { isDustAllocation } from '@/helpers/dust'

interface MarketPositionStateLike {
  supplyAssets?: BigIntish | null
  supplyAssetsUsd?: number | null
  supplyShares?: BigIntish | null
  borrowShares?: BigIntish | null
  collateral?: BigIntish | null
}

// The "Your Position" widgets (data list, borrow chart) must agree on what a
// lend-only position is — keep both gates on these shared predicates.
// Asset-denominated withdrawals on Blue round shares up, so a "withdraw all"
// done in assets (Etherscan, third-party UIs) can strand a few wei of supply
// shares; a dust position is treated as non-existent.
export function getHasLendPosition(state: MarketPositionStateLike | null | undefined): boolean {
  if ((toBigInt(state?.supplyShares) ?? 0n) <= 0n) return false

  return !isDustAllocation(state?.supplyAssetsUsd)
}

export function getHasBorrowPosition(state: MarketPositionStateLike | null | undefined): boolean {
  return (toBigInt(state?.borrowShares) ?? 0n) > 0n || (toBigInt(state?.collateral) ?? 0n) > 0n
}
